import * as yup from 'yup';
import { Row, RenderConfig, TextInput, SelectInput } from 'commons-ui';

const APP_NAME_OPTIONS = [{ id: 'in.ludo.supremegold', label: 'in.ludo.supremegold' }];

export const FORM_FIELD_KEYS = {
	PERMISSION_NAME: 'resourceName',
	PERMISSION_DESCRIPTION: 'description',
	PERMISSION_ACTION: 'actionName',
	PAGE_NAME: 'pageName',
	APP_NAME: 'appName'
};
export const validationSchema = yup.object().shape({
	resourceName: yup.string().required('Permission Name is required')
});

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.PERMISSION_NAME),
	new Row(FORM_FIELD_KEYS.PERMISSION_DESCRIPTION),
	new Row(FORM_FIELD_KEYS.PERMISSION_ACTION),
	new Row(FORM_FIELD_KEYS.PAGE_NAME),
	new Row(FORM_FIELD_KEYS.APP_NAME)
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.PERMISSION_NAME]: new RenderConfig()
		.setName('resourceName')
		.setLabel('Permission Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.PERMISSION_DESCRIPTION]: new RenderConfig()
		.setName('description')
		.setLabel('Permission Description')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.PERMISSION_ACTION]: new RenderConfig()
		.setName('actionName')
		.setLabel('Permission Action')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.PAGE_NAME]: new RenderConfig()
		.setName('pageName')
		.setLabel('Page Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.APP_NAME]: new RenderConfig()
		.setName('appName')
		.setLabel('App Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			isHidden: { create: false, edit: true },
			options: APP_NAME_OPTIONS
		})
};
